// Shared palette for the whole Issue feature — extracted from
// IssueResolutionPage.jsx (the reference implementation) so every issue
// surface (list, kanban, viewer, create form, approval queue, analytics)
// pulls from the same BidLight tokens instead of ad-hoc grays/blues.
//
// The look: white cards on #FAFAFA, #EFEFEF borders, navy text hierarchy,
// orange (#FE6919) reserved for the single most important CTA.
export const T = {
  ink: "#23343E", text: "#3A4952", muted: "#8D8D8D", sub: "#AEAEAE",
  line: "#EFEFEF", line2: "#E2E2E2", bg: "#FAFAFA", wash: "#E9F1F5",
  navy: "#455D6B", navyD: "#3A5765",
  orange: "#FE6919",
  added: "#4FC92A", addedBg: "#EEFBE9", added2: "#317A1B",
  removed: "#FB8080", removedBg: "#FFF0F0", removed2: "#C53030",
  amber: "#E0A43A", ambBg: "#FDF4E1",
};

// Flat colors — chart fills, status dots, column-header markers.
export const STATUS_COLORS = {
  open: T.navy,        // #455D6B
  pending: T.amber,    // #E0A43A
  resolved: T.added,   // #4FC92A
  abandoned: T.muted,  // #8D8D8D
};

export const PRIORITY_COLORS = {
  urgent: T.removed2,  // #C53030 — danger stays red-family
  normal: T.navy,      // #455D6B
  low: T.muted,        // #8D8D8D
};

// Chip / badge triples (background, border, foreground) matching the Pill
// kinds already used on the resolution page.
export const STATUS_CHIPS = {
  open:      { bg: T.wash,      bd: "#D4E3EC", fg: T.navyD },
  pending:   { bg: T.ambBg,     bd: "#F1DFB1", fg: "#8A6112" },
  resolved:  { bg: T.addedBg,   bd: "#CDEEC1", fg: T.added2 },
  abandoned: { bg: "#F3F4F5",   bd: "#E8EAEC", fg: "#526470" },
};

export const PRIORITY_CHIPS = {
  urgent: { bg: T.removedBg, bd: "#FAD6D6", fg: T.removed2 },
  normal: { bg: T.wash,      bd: "#D4E3EC", fg: T.navyD },
  low:    { bg: "#F3F4F5",   bd: "#E8EAEC", fg: "#526470" },
};
